var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown',{ref:"dropdown",staticClass:"site-header__contact",attrs:{"hover":"small","align":_vm.align,"data-navigation":"Contact Us"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }